import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CurrentUserResponse } from './types';
import { getCurrentUser, updateCurrentUser, updateUserStatus } from './api';
import { useNavigate } from 'react-router-dom';
import { queryClient } from 'providers/AllProviders';

export function useGetCurrentUser(options?: UseQueryOptions<CurrentUserResponse, Error>) {
  return useQuery<CurrentUserResponse>({
    queryKey: ['currentUser'],
    queryFn: () => getCurrentUser(),
    ...options
  });
}

export function useUpdateCurrentUser(isImageUploadOnly?: boolean) {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (payload: any) => updateCurrentUser(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['currentUser'],
        refetchType: 'active'
      });
      if (!isImageUploadOnly) {
        navigate(-1);
      }
    }
  });
}

export function useUpdateUserStatus() {
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: any }) => updateUserStatus(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['businessProfile'],
        refetchType: 'active'
      });
    },
    onError: (error) => {
      console.error('Failed to update user status:', error);
    }
  });
}
